<template>
  <div class="lottery-wrap">
    <div
      v-for="item in module.couponList"
      :key="item.stageId"
      class="stage-item"
    >
      <div class="title">
        {{ item.stageTitle }}
      </div>
      <div class="coupon-list">
        <div
          v-for="coupon in item.gifts"
          :key="coupon.modelId"
          class="coupon-item"
        >
          <div class="left">
            <span class="value"
              ><span class="unit">¥</span>{{ coupon.faceValue }}</span
            >
            <div class="threshold">
              {{ coupon.thresholdMsg }}
            </div>
          </div>
          <div class="right">
            <div class="coupon-name">
              {{ coupon.couponDisplayName }}
            </div>
            <div class="desc">
              {{ coupon.description }}
            </div>
            <div class="num">
              <span>{{ coupon.num }}</span>
              <span class="unit">张</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CouponLottery',
  props: {
    module: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.lottery-wrap {
  padding: 0 0.3rem;

  overflow: hidden;

  background-repeat: no-repeat;
  background-size: 100% 100%;
  .stage-item {
    margin-bottom: 0.5rem;
    .title {
      width: 98px;
      height: 26px;
      margin-bottom: 10px;

      background-image: linear-gradient(to right, #fff1e8 0%, #ffdecd 100%);
      border-radius: 12px 12px 12px 0;

      font-size: 15px;

      line-height: 26px;
      text-align: center;
      color: #ff5c00;
    }
    .coupon-item {
      display: flex;

      width: 6.9rem;
      height: 1.68rem;

      margin-bottom: 5px;

      background-image: url('~@/images/cms/coupons/coupon_bg@3x.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;

      &:nth-last-child(1) {
        margin-bottom: 0;
      }

      .left {
        width: 2.08rem;
        height: 100%;

        flex: none;
        @include flex-column-center;
        .unit {
          font-size: 0.32rem;
          color: #ff5c00;
        }
        .value {
          font-size: 0.72rem;
          color: #ff5c00;
        }
        .threshold {
          width: 100%;
          margin-top: 0.14rem;
          padding: 0 0.2rem;

          font-size: 0.24rem;
          text-align: center;
          color: #ff5c00;
          box-sizing: border-box;
          @include text-overflow-ellipsis-single;
        }
      }
      .right {
        position: relative;

        padding: 0 0.96rem 0 0.4rem;

        flex: 1;

        @include flex(column, center);
        .coupon-name {
          font-size: 0.3rem;
          font-weight: 600;
          @include text-overflow-ellipsis-single;
        }
        .desc {
          width: 100%;
          max-height: 0.68rem;
          margin-top: 0.14rem;

          font-size: 0.26rem;
          line-height: 0.34rem;
          color: #666666;
          @include text-overflow-ellipsis-multiple;
        }
        .num {
          position: absolute;
          top: 50%;
          right: -3px;
          transform: translateY(-50%);

          width: 0.48rem;
          height: 1.2rem;

          background-image: url('~@/images/cms/coupons/coupon_num_bg.png');
          background-repeat: no-repeat;

          font-size: 0.26rem;

          background-size: 100% 100%;
          @include flex-column-center;
          span {
            color: #ff5c00;
          }
          .unit {
            margin-top: 0.06rem;
          }
        }
      }
    }
  }
}
</style>
